module.exports = __webpack_public_path__ + "src/assets/images/signin.30d39d948cf69ac1122afe7784cd69ca.png";